export default __webpack_public_path__ + "static/media/03_photo.f3289ea2.jpeg";